import { userConstants } from "../constants/login.constants";

 function digitalSignatureStatement(state = {}, action) {
    switch (action.type) {
        case userConstants.DIGITALSIGNATURESTATEMENT_REQUEST:
            return {
                loading: true
            };
        case userConstants.DIGITALSIGNATURESTATEMENT_SUCCESS:
            return {
                items: action.digitalSignatureStatement
            };
        case userConstants.DIGITALSIGNATURESTATEMENT_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}
export default digitalSignatureStatement;